export default {
  title: 'Eigene Domain',
  description:
    'Betreiben Sie die Apps Ihres Teams auf einer eigenen Domain statt auf der gemeinsamen Adresse. Sie verbinden die Domain einmal: Dashboard, Bestellportal, Website-Editor und Website-Studio erhalten darunter jeweils eine eigene Adresse.',
  read_only_description:
    'Die Domain, auf der dieser Partner seine Apps betreibt. Nur der Partner kann sie verbinden oder trennen.',
  read_only_empty: 'Dieser Partner hat keine Domain verbunden.',
  not_connected: {
    label: 'Domain',
    hint: 'Die Domain, die Ihnen gehört, ohne www — zum Beispiel ihremarke.de. Die angezeigten DNS-Einträge legen Sie anschließend bei Ihrem Domain-Anbieter an.',
    placeholder: 'ihremarke.de',
    connect: 'Verbinden',
  },
  apps: {
    dashboard: 'Dashboard',
    oms: 'Bestellportal',
    storefront: 'Website-Editor',
    website_studio: 'Website-Studio',
  },
  status: {
    active: 'Live',
    pending: 'Wartet auf DNS',
    failed: 'Handlungsbedarf',
    disabled: 'Getrennt',
  },
  records: {
    title: 'Legen Sie diese DNS-Einträge für {{root}} bei Ihrem Domain-Anbieter an',
  },
  instructions: {
    title: 'So legen Sie die Einträge an',
    step_provider:
      'Melden Sie sich dort an, wo das DNS von {{root}} verwaltet wird — meist bei dem Anbieter, bei dem Sie die Domain gekauft haben, oder bei einem DNS-Dienst wie Cloudflare.',
    step_add:
      'Öffnen Sie die DNS-Einstellungen von {{root}} und legen Sie jeden Eintrag unten an: Wählen Sie den Typ und kopieren Sie Name und Wert unverändert. Die TTL bleibt auf dem Standardwert.',
    step_check:
      'Speichern Sie die Einträge und klicken Sie auf „{{button}}“. Die meisten Anbieter übernehmen Änderungen innerhalb weniger Minuten, manche brauchen bis zu 48 Stunden.',
    tip_name:
      'Im Namensfeld erwarten die meisten Anbieter nur den Teil vor {{root}}, der fett dargestellt ist. Verlangt Ihr Anbieter den vollständigen Namen, kopieren Sie den darunter.',
    tip_cloudflare:
      'Stellen Sie bei Cloudflare die CNAME-Einträge auf „Nur DNS“ (graue Wolke). Ein Eintrag über den Proxy verbirgt den CNAME, sodass die Domain nicht bestätigt werden kann.',
    tip_existing:
      'Lassen Sie Ihre bestehenden Einträge für {{root}} und www unverändert — Ihre Website läuft weiter wie bisher.',
  },
  summary: {
    live: 'Ihr Dashboard ist unter {{host}} live.',
    pending:
      'Wir prüfen Ihre DNS-Einträge regelmäßig. Bis neue Einträge gefunden werden, kann es bis zu 48 Stunden dauern.',
    failed:
      'Einige Einträge konnten nicht bestätigt werden. Korrigieren Sie die unten markierten Einträge und prüfen Sie erneut.',
    relogin:
      'Sobald {{host}} live ist, meldet sich Ihr Team dort an. Beim ersten Besuch ist eine erneute Anmeldung nötig.',
  },
  buttons: {
    check_again: 'Erneut prüfen',
    disconnect: 'Trennen',
    retry: 'Erneut versuchen',
  },
  disconnect_confirm: {
    title: '{{root}} trennen?',
    description:
      'Ihre Apps laufen dann wieder unter der gemeinsamen Adresse, und Links auf {{root}} funktionieren nicht mehr.',
    ok: 'Trennen',
  },
  toasts: {
    load_error: 'Ihre Domain konnte nicht geladen werden.',
    load_error_read_only: 'Die Domain dieses Partners konnte nicht geladen werden.',
    connected: 'Domain verbunden. Legen Sie die DNS-Einträge unten an.',
    connect_failed: 'Die Domain konnte nicht verbunden werden.',
    check_started: 'Ihre DNS-Einträge werden geprüft.',
    check_failed: 'Die Prüfung konnte nicht gestartet werden. Versuchen Sie es in einer Minute erneut.',
    disconnected: 'Domain getrennt.',
    disconnect_failed: 'Die Domain konnte nicht getrennt werden.',
  },
};
